export default "__VITE_ASSET__CH3VFs15__ 400w, __VITE_ASSET__Bl9YuTVi__ 800w, __VITE_ASSET__Ad6fSF5W__ 1024w";